import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useBreakpoints } from '@mopla/utils';

import { MplButton } from '../../atoms/MplButton/MplButton';
import { Responsive2ButtonsFooter } from '../../layouts/Responsive2ButtonsFooter';

export interface IFormFooterV2Props {
	isUserProfile: boolean;
	onCancel(): void;
	isSubmitDisabled: boolean;
	isSubmitting?: boolean;
}

export const FormFooterV2: FC<IFormFooterV2Props> = ({
	isUserProfile,
	onCancel,
	isSubmitDisabled,
	isSubmitting,
}) => {
	const { t } = useTranslation(['profile', 'personalDetails']);
	const { isMobile } = useBreakpoints();

	if (!isUserProfile) {
		return (
			<MplButton
				fullWidth
				data-testid="personal-detailsForm-submit-button"
				showLoader={isSubmitting}
				disabled={isSubmitDisabled}
				type="submit"
				form="personalDetailsForm"
			>
				{t('personalDetails:button.complete_registration')}
			</MplButton>
		);
	}

	/** TODO MC-5177 fixme */
	const cancelBtn = (
		<MplButton
			fullWidth
			className="cancelButton"
			variant="text"
			onClick={onCancel}
		>
			{t('button.abort')}
		</MplButton>
	);

	const submitBtn = (
		<MplButton
			fullWidth
			color={isMobile ? 'primaryRevert' : 'primary'}
			data-testid="personal-detailsForm-submit-button"
			showLoader={isSubmitting}
			disabled={isSubmitDisabled}
			type="submit"
			form="personalDetailsForm"
		>
			{t('button.save')}
		</MplButton>
	);

	return (
		<Responsive2ButtonsFooter cancelBtn={cancelBtn} submitBtn={submitBtn} />
	);
};
